export const categories = [
  { id: "all", name: "全部", slug: "all" },
  { id: "romance", name: "恋爱", slug: "romance" },
  { id: "fantasy", name: "奇幻", slug: "fantasy" },
  { id: "action", name: "动作", slug: "action" },
  { id: "drama", name: "剧情", slug: "drama" },
  { id: "comedy", name: "搞笑", slug: "comedy" },
  { id: "suspense", name: "悬疑", slug: "suspense" },
  { id: "bl", name: "耽美", slug: "bl" },
  { id: "gl", name: "百合", slug: "gl" },
];

export const comics = [
  {
    id: "c001",
    slug: "my-dearest-enemy",
    title: "我的死对头",
    author: "金秀雅",
    cover: "https://readdy.ai/api/search-image?query=A%20Korean%20romance%20manhwa%20cover%20art%20style%2C%20two%20young%20adults%20facing%20each%20other%20with%20tense%20expressions%20on%20a%20university%20campus%20background%2C%20soft%20pastel%20colors%2C%20delicate%20linework%2C%20webtoon%20illustration%20style%2C%20clean%20white%20background%20with%20subtle%20cherry%20blossom%20petals&width=400&height=560&seq=comic-cover-001&orientation=portrait",
    category: "romance",
    categoryName: "恋爱",
    description: "一个是学校公认的学霸，一个是永远的第二名。从入学那天起，林予就和江辞结下了说不清的梁子。然而一次意外的合作，让两个针锋相对的人开始重新认识对方……",
    status: "连载中",
    updatedAt: "2026-08-04",
    rating: 9.5,
    views: 1256000,
    chapters: [
      { id: "ch001", number: 1, title: "命运的相遇", updatedAt: "2026-01-15" },
      { id: "ch002", number: 2, title: "第二次对决", updatedAt: "2026-01-22" },
      { id: "ch003", number: 3, title: "意外的搭档", updatedAt: "2026-02-01" },
      { id: "ch004", number: 4, title: "深夜图书馆", updatedAt: "2026-02-10" },
      { id: "ch005", number: 5, title: "心跳加速", updatedAt: "2026-02-20" },
      { id: "ch006", number: 6, title: "告白前夕", updatedAt: "2026-03-01" },
      { id: "ch007", number: 7, title: "你的答案", updatedAt: "2026-03-15" },
      { id: "ch008", number: 8, title: "新的开始", updatedAt: "2026-04-01" },
    ],
  },
  {
    id: "c002",
    slug: "dragon-king-returns",
    title: "龙王归来",
    author: "李贤俊",
    cover: "https://readdy.ai/api/search-image?query=A%20fantasy%20Korean%20manhwa%20cover%2C%20a%20powerful%20dragon%20warrior%20with%20flowing%20black%20hair%20holding%20a%20glowing%20sword%2C%20mystical%20energy%20surrounding%20him%2C%20dark%20dramatic%20background%20with%20golden%20accents%2C%20epic%20webtoon%20art%20style&width=400&height=560&seq=comic-cover-002&orientation=portrait",
    category: "fantasy",
    categoryName: "奇幻",
    description: "万年前被封印的龙王转世为一个普通少年。当黑暗势力再次降临，沉睡的力量开始苏醒。一朝龙王觉醒，天下风云再起！",
    status: "连载中",
    updatedAt: "2026-08-03",
    rating: 9.7,
    views: 2890000,
    chapters: [
      { id: "ch101", number: 1, title: "平凡少年的日常", updatedAt: "2025-12-01" },
      { id: "ch102", number: 2, title: "封印松动", updatedAt: "2025-12-08" },
      { id: "ch103", number: 3, title: "初次觉醒", updatedAt: "2025-12-15" },
      { id: "ch104", number: 4, title: "龙之力", updatedAt: "2025-12-22" },
      { id: "ch105", number: 5, title: "黑龙来袭", updatedAt: "2026-01-05" },
      { id: "ch106", number: 6, title: "决战之巅", updatedAt: "2026-01-15" },
    ],
  },
  {
    id: "c003",
    slug: "night-blade",
    title: "暗夜之刃",
    author: "朴志浩",
    cover: "https://readdy.ai/api/search-image?query=A%20dark%20action%20Korean%20manhwa%20cover%2C%20a%20masked%20assassin%20in%20black%20clothing%20holding%20twin%20daggers%2C%20moonlit%20rooftop%20scene%2C%20neon%20city%20lights%20in%20background%2C%20dramatic%20lighting%2C%20sharp%20clean%20webtoon%20illustration%20style&width=400&height=560&seq=comic-cover-003&orientation=portrait",
    category: "action",
    categoryName: "动作",
    description: "首尔的夜晚，一个神秘的黑衣人在城市暗处伸张正义。他的真实身份无人知晓，但每一个罪犯都害怕他的名字——暗夜之刃。",
    status: "已完结",
    updatedAt: "2026-06-15",
    rating: 9.4,
    views: 1980000,
    chapters: [
      { id: "ch201", number: 1, title: "面具之下", updatedAt: "2025-08-01" },
      { id: "ch202", number: 2, title: "第一条线索", updatedAt: "2025-08-10" },
      { id: "ch203", number: 3, title: "夜幕降临", updatedAt: "2025-08-20" },
      { id: "ch204", number: 4, title: "宿敌现身", updatedAt: "2025-09-01" },
    ],
  },
  {
    id: "c004",
    slug: "tears-of-the-moon",
    title: "月之泪",
    author: "崔恩珠",
    cover: "https://readdy.ai/api/search-image?query=A%20beautiful%20melancholic%20Korean%20drama%20manhwa%20cover%2C%20a%20young%20woman%20in%20traditional%20hanbok%20under%20moonlight%2C%20tears%20on%20her%20cheek%2C%20ancient%20palace%20in%20background%2C%20soft%20silver%20and%20blue%20tones%2C%20emotional%20webtoon%20art%20style&width=400&height=560&seq=comic-cover-004&orientation=portrait",
    category: "drama",
    categoryName: "剧情",
    description: "朝鲜时代，一位贵族少女被迫入宫成为王妃。在权力的漩涡中，她遇到了真心爱她的人，但命运却开了一个残酷的玩笑。一段跨越阶级与生死的爱恋。",
    status: "已完结",
    updatedAt: "2026-05-20",
    rating: 9.6,
    views: 1560000,
    chapters: [
      { id: "ch301", number: 1, title: "赐婚", updatedAt: "2025-06-01" },
      { id: "ch302", number: 2, title: "初入宫闱", updatedAt: "2025-06-10" },
      { id: "ch303", number: 3, title: "月光下的约定", updatedAt: "2025-06-20" },
      { id: "ch304", number: 4, title: "阴谋浮现", updatedAt: "2025-07-01" },
      { id: "ch305", number: 5, title: "生死相随", updatedAt: "2025-07-15" },
    ],
  },
  {
    id: "c005",
    slug: "daily-life-of-a-swordsman",
    title: "剑客的日常",
    author: "郑宇硕",
    cover: "https://readdy.ai/api/search-image?query=A%20light%20hearted%20comedy%20Korean%20manhwa%20cover%2C%20a%20handsome%20swordsman%20in%20traditional%20martial%20arts%20clothing%20looking%20confused%20and%20funny%2C%20chibi%20style%20mini%20characters%20around%20him%2C%20bright%20cheerful%20colors%2C%20humorous%20webtoon%20illustration&width=400&height=560&seq=comic-cover-005&orientation=portrait",
    category: "comedy",
    categoryName: "搞笑",
    description: "天下第一剑客退休后，只想在乡下开一家小茶馆。但江湖的人偏偏不让他安宁。每天都有各种奇怪的人找上门来挑战、拜师、或者蹭茶喝……",
    status: "连载中",
    updatedAt: "2026-08-02",
    rating: 9.3,
    views: 987000,
    chapters: [
      { id: "ch401", number: 1, title: "退休第一天", updatedAt: "2026-04-01" },
      { id: "ch402", number: 2, title: "不速之客", updatedAt: "2026-04-08" },
      { id: "ch403", number: 3, title: "茶馆开张", updatedAt: "2026-04-15" },
      { id: "ch404", number: 4, title: "大侠来蹭茶", updatedAt: "2026-04-22" },
    ],
  },
  {
    id: "c006",
    slug: "the-secret-room",
    title: "密室",
    author: "宋敏俊",
    cover: "https://readdy.ai/api/search-image?query=A%20thriller%20suspense%20Korean%20manhwa%20cover%2C%20a%20dimly%20lit%20room%20with%20a%20single%20door%2C%20mysterious%20shadow%20figure%2C%20eerie%20atmosphere%2C%20blood%20red%20accents%2C%20psychological%20thriller%20vibe%2C%20dark%20moody%20webtoon%20art%20style&width=400&height=560&seq=comic-cover-006&orientation=portrait",
    category: "suspense",
    categoryName: "悬疑",
    description: "六个陌生人在一间密室中醒来，他们不记得自己是谁，也不知为何会在这里。每隔一小时，就会有一个人消失。他们必须在时间耗尽前找出真相。",
    status: "连载中",
    updatedAt: "2026-08-01",
    rating: 9.8,
    views: 3120000,
    chapters: [
      { id: "ch501", number: 1, title: "醒来", updatedAt: "2026-05-01" },
      { id: "ch502", number: 2, title: "第一人消失", updatedAt: "2026-05-08" },
      { id: "ch503", number: 3, title: "线索", updatedAt: "2026-05-15" },
      { id: "ch504", number: 4, title: "猜疑", updatedAt: "2026-05-22" },
      { id: "ch505", number: 5, title: "第二个牺牲者", updatedAt: "2026-06-01" },
      { id: "ch506", number: 6, title: "真相浮现", updatedAt: "2026-06-10" },
    ],
  },
  {
    id: "c007",
    slug: "cherry-blossom-love",
    title: "樱花恋歌",
    author: "尹智恩",
    cover: "https://readdy.ai/api/search-image?query=A%20beautiful%20BL%20boys%20love%20Korean%20manhwa%20cover%2C%20two%20handsome%20young%20men%20standing%20under%20cherry%20blossom%20trees%2C%20gazing%20at%20each%20other%20tenderly%2C%20soft%20pink%20and%20white%20color%20palette%2C%20romantic%20atmosphere%2C%20delicate%20webtoon%20art%20style&width=400&height=560&seq=comic-cover-007&orientation=portrait",
    category: "bl",
    categoryName: "耽美",
    description: "音乐学院的钢琴天才宇贤，遇到了转学生泰河。两个少年在樱花树下许下约定，用音乐谱写了一段属于他们的青春恋曲。",
    status: "连载中",
    updatedAt: "2026-08-03",
    rating: 9.6,
    views: 2340000,
    chapters: [
      { id: "ch601", number: 1, title: "转学生", updatedAt: "2026-03-01" },
      { id: "ch602", number: 2, title: "钢琴教室", updatedAt: "2026-03-08" },
      { id: "ch603", number: 3, title: "四手联弹", updatedAt: "2026-03-15" },
      { id: "ch604", number: 4, title: "樱花纷飞", updatedAt: "2026-03-22" },
    ],
  },
  {
    id: "c008",
    slug: "garden-of-lilies",
    title: "百合花园",
    author: "姜秀晶",
    cover: "https://readdy.ai/api/search-image?query=A%20GL%20girls%20love%20Korean%20manhwa%20cover%2C%20two%20beautiful%20young%20women%20holding%20hands%20in%20a%20lush%20garden%20filled%20with%20white%20lilies%2C%20soft%20sunlight%20filtering%20through%20leaves%2C%20gentle%20pastel%20green%20and%20white%20tones%2C%20romantic%20webtoon%20art%20style&width=400&height=560&seq=comic-cover-008&orientation=portrait",
    category: "gl",
    categoryName: "百合",
    description: "花艺师素英在自己经营的小花店里，遇到了来买花的画家允儿。一朵白色百合花，开启了两颗孤独心灵之间的温暖故事。",
    status: "已完结",
    updatedAt: "2026-04-30",
    rating: 9.5,
    views: 876000,
    chapters: [
      { id: "ch701", number: 1, title: "花店相遇", updatedAt: "2026-02-01" },
      { id: "ch702", number: 2, title: "白色百合", updatedAt: "2026-02-08" },
      { id: "ch703", number: 3, title: "画与花", updatedAt: "2026-02-15" },
    ],
  },
  {
    id: "c009",
    slug: "magic-academy-king",
    title: "魔法学院之王",
    author: "韩载民",
    cover: "https://readdy.ai/api/search-image?query=A%20fantasy%20magic%20academy%20Korean%20manhwa%20cover%2C%20a%20young%20mage%20with%20sparkling%20blue%20magic%20energy%20in%20his%20hands%2C%20grand%20magical%20academy%20building%20behind%2C%20floating%20spell%20circles%2C%20vibrant%20mystical%20colors%2C%20epic%20webtoon%20illustration%20style&width=400&height=560&seq=comic-cover-009&orientation=portrait",
    category: "fantasy",
    categoryName: "奇幻",
    description: "被认为是魔法废柴的少年，在一次意外中觉醒了远古血脉。从此踏上征服魔法学院、成为最强的道路。",
    status: "连载中",
    updatedAt: "2026-08-03",
    rating: 9.4,
    views: 1670000,
    chapters: [
      { id: "ch801", number: 1, title: "废柴少年", updatedAt: "2026-04-01" },
      { id: "ch802", number: 2, title: "血脉觉醒", updatedAt: "2026-04-10" },
      { id: "ch803", number: 3, title: "入学考试", updatedAt: "2026-04-20" },
      { id: "ch804", number: 4, title: "初露锋芒", updatedAt: "2026-05-01" },
    ],
  },
  {
    id: "c010",
    slug: "revenge-marriage",
    title: "复仇式婚姻",
    author: "金秀雅",
    cover: "https://readdy.ai/api/search-image?query=A%20dramatic%20romance%20Korean%20manhwa%20cover%2C%20a%20beautiful%20woman%20in%20an%20elegant%20wedding%20dress%20with%20a%20cold%20expression%2C%20luxurious%20mansion%20background%2C%20dramatic%20contrast%20between%20white%20dress%20and%20dark%20surroundings%2C%20intense%20emotional%20webtoon%20art%20style&width=400&height=560&seq=comic-cover-010&orientation=portrait",
    category: "romance",
    categoryName: "恋爱",
    description: "为了向毁掉自己家族的人复仇，她嫁给了仇人的儿子。却没想到在这场精心策划的复仇婚姻中，她渐渐对那个温柔的男人动了真心……",
    status: "连载中",
    updatedAt: "2026-08-02",
    rating: 9.3,
    views: 1430000,
    chapters: [
      { id: "ch901", number: 1, title: "婚约", updatedAt: "2026-05-01" },
      { id: "ch902", number: 2, title: "新婚之夜", updatedAt: "2026-05-08" },
      { id: "ch903", number: 3, title: "他的温柔", updatedAt: "2026-05-15" },
      { id: "ch904", number: 4, title: "动摇的心", updatedAt: "2026-05-22" },
    ],
  },
  {
    id: "c011",
    slug: "street-fighter-kim",
    title: "街头拳王",
    author: "朴志浩",
    cover: "https://readdy.ai/api/search-image?query=An%20action%20fighting%20Korean%20manhwa%20cover%2C%20a%20muscular%20young%20fighter%20with%20bandaged%20fists%20in%20a%20fighting%20stance%2C%20urban%20street%20alley%20background%20with%20graffiti%2C%20dynamic%20action%20pose%2C%20gritty%20realistic%20webtoon%20art%20style&width=400&height=560&seq=comic-cover-011&orientation=portrait",
    category: "action",
    categoryName: "动作",
    description: "一个来自贫民窟的少年，用双拳打出了属于自己的天下。在地下格斗的世界里，只有强者才能生存！",
    status: "连载中",
    updatedAt: "2026-08-01",
    rating: 9.2,
    views: 1120000,
    chapters: [
      { id: "ch1001", number: 1, title: "第一场战斗", updatedAt: "2026-06-01" },
      { id: "ch1002", number: 2, title: "地下拳场", updatedAt: "2026-06-08" },
      { id: "ch1003", number: 3, title: "连胜", updatedAt: "2026-06-15" },
    ],
  },
  {
    id: "c012",
    slug: "my-boss-is-a-cat",
    title: "老板是只猫",
    author: "郑宇硕",
    cover: "https://readdy.ai/api/search-image?query=A%20cute%20comedy%20Korean%20manhwa%20cover%2C%20a%20fluffy%20orange%20cat%20wearing%20a%20tiny%20business%20suit%20and%20tie%20sitting%20on%20an%20office%20desk%2C%20adorable%20funny%20vibe%2C%20bright%20office%20setting%2C%20charming%20webtoon%20illustration&width=400&height=560&seq=comic-cover-012&orientation=portrait",
    category: "comedy",
    categoryName: "搞笑",
    description: "新入职的社畜发现自己部门的部长居然是一只猫？！更离谱的是，这只猫还真的会管理团队。荒诞又温馨的职场喜剧！",
    status: "连载中",
    updatedAt: "2026-08-04",
    rating: 9.1,
    views: 654000,
    chapters: [
      { id: "ch1101", number: 1, title: "入职第一天", updatedAt: "2026-07-01" },
      { id: "ch1102", number: 2, title: "猫部长的指示", updatedAt: "2026-07-08" },
      { id: "ch1103", number: 3, title: "午休时间", updatedAt: "2026-07-15" },
    ],
  },
  {
    id: "c013",
    slug: "ghost-in-the-library",
    title: "图书馆的幽灵",
    author: "宋敏俊",
    cover: "https://readdy.ai/api/search-image?query=A%20mystery%20suspense%20Korean%20manhwa%20cover%2C%20an%20old%20dusty%20library%20with%20tall%20bookshelves%2C%20a%20translucent%20ghostly%20figure%20reading%20a%20book%2C%20dust%20motes%20in%20moonlight%20beams%2C%20eerie%20yet%20beautiful%20atmosphere%2C%20dark%20academic%20webtoon%20art&width=400&height=560&seq=comic-cover-013&orientation=portrait",
    category: "suspense",
    categoryName: "悬疑",
    description: "深夜的大学图书馆，总有人看到一个白衣女子的身影。是传说还是真相？一群好奇心旺盛的学生决定一探究竟。",
    status: "已完结",
    updatedAt: "2026-07-01",
    rating: 9.0,
    views: 543000,
    chapters: [
      { id: "ch1201", number: 1, title: "深夜图书馆", updatedAt: "2026-06-01" },
      { id: "ch1202", number: 2, title: "白衣女子", updatedAt: "2026-06-08" },
      { id: "ch1203", number: 3, title: "三十年前的秘密", updatedAt: "2026-06-15" },
    ],
  },
  {
    id: "c014",
    slug: "the-queens-shadow",
    title: "女王的影子",
    author: "崔恩珠",
    cover: "https://readdy.ai/api/search-image?query=A%20historical%20drama%20Korean%20manhwa%20cover%2C%20a%20regal%20queen%20in%20elaborate%20traditional%20royal%20hanbok%20sitting%20on%20a%20throne%2C%20her%20shadow%20showing%20a%20different%20sinister%20figure%2C%20palace%20interior%2C%20dramatic%20lighting%2C%20elegant%20webtoon%20art&width=400&height=560&seq=comic-cover-014&orientation=portrait",
    category: "drama",
    categoryName: "剧情",
    description: "她是朝鲜历史上最传奇的王妃，以智慧和勇气辅佐君王。但在光鲜的背后，隐藏着一段不为人知的辛酸往事。",
    status: "连载中",
    updatedAt: "2026-08-02",
    rating: 9.7,
    views: 1890000,
    chapters: [
      { id: "ch1301", number: 1, title: "入宫", updatedAt: "2026-05-01" },
      { id: "ch1302", number: 2, title: "后宫争斗", updatedAt: "2026-05-10" },
      { id: "ch1303", number: 3, title: "王的女人", updatedAt: "2026-05-20" },
      { id: "ch1304", number: 4, title: "影子的秘密", updatedAt: "2026-06-01" },
    ],
  },
  {
    id: "c015",
    slug: "love-at-first-bite",
    title: "一口定情",
    author: "尹智恩",
    cover: "https://readdy.ai/api/search-image?query=A%20sweet%20romantic%20Korean%20food%20themed%20manhwa%20cover%2C%20a%20cute%20couple%20sharing%20a%20plate%20of%20tteokbokki%20at%20a%20street%20food%20stall%2C%20steam%20rising%20from%20food%2C%20warm%20evening%20lights%2C%20cozy%20atmosphere%2C%20heartwarming%20webtoon%20illustration&width=400&height=560&seq=comic-cover-015&orientation=portrait",
    category: "romance",
    categoryName: "恋爱",
    description: "美食博主遇上了厨艺天才，从一口辣炒年糕开始的甜蜜爱情故事。每一话都附带食谱彩蛋，看漫画的同时还能学做韩料！",
    status: "连载中",
    updatedAt: "2026-08-04",
    rating: 9.5,
    views: 765000,
    chapters: [
      { id: "ch1401", number: 1, title: "辣味邂逅", updatedAt: "2026-07-01" },
      { id: "ch1402", number: 2, title: "第二口", updatedAt: "2026-07-08" },
      { id: "ch1403", number: 3, title: "他的厨房", updatedAt: "2026-07-15" },
    ],
  },
  {
    id: "c016",
    slug: "blade-of-destiny",
    title: "命运之刃",
    author: "韩载民",
    cover: "https://readdy.ai/api/search-image?query=An%20epic%20fantasy%20Korean%20manhwa%20cover%2C%20a%20lone%20warrior%20with%20a%20cursed%20black%20blade%20standing%20on%20a%20cliff%20edge%2C%20stormy%20sky%20with%20lightning%2C%20ancient%20ruins%20below%2C%20dramatic%20cinematic%20composition%2C%20dark%20epic%20webtoon%20art%20style&width=400&height=560&seq=comic-cover-016&orientation=portrait",
    category: "fantasy",
    categoryName: "奇幻",
    description: "一把被诅咒的魔剑选择了它的主人，从此少年的命运与剑的意志交织在一起。弑神还是救世？一切取决于持剑者的选择。",
    status: "连载中",
    updatedAt: "2026-08-02",
    rating: 9.6,
    views: 2100000,
    chapters: [
      { id: "ch1501", number: 1, title: "魔剑出世", updatedAt: "2026-05-01" },
      { id: "ch1502", number: 2, title: "被选中的人", updatedAt: "2026-05-10" },
      { id: "ch1503", number: 3, title: "剑灵", updatedAt: "2026-05-20" },
      { id: "ch1504", number: 4, title: "第一战", updatedAt: "2026-06-01" },
    ],
  },
];

export const hotComics = comics.filter((c) => c.rating >= 9.5 && c.views >= 1500000);
export const latestUpdates = [...comics].sort((a, b) => b.updatedAt.localeCompare(a.updatedAt));
export const popularComics = [...comics].sort((a, b) => b.views - a.views);

export function getComicsByCategory(slug: string) {
  if (slug === "all") return comics;
  return comics.filter((c) => c.category === slug);
}

export function getComicBySlug(slug: string) {
  return comics.find((c) => c.slug === slug) || null;
}

export function getCategoryBySlug(slug: string) {
  return categories.find((c) => c.slug === slug) || null;
}